﻿$.fn.dxCtrlBuilderEmailPageListeBouton = function custom_dxCtrlBuilderEmailPageListeBouton(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailpagelistebouton dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailPageListeBouton(this, option));
    }
    return this;
}

window.lstWidgetPerso = null
window.cdxCtrlBuilderEmailPageListeBouton = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    option.bddCtrl.mAddFunctionOnModifiedItemData(["widget_email"], container,
        function (action, itemData) {
            //window.clearTimeout(timeOutUpdate)
            if (action == "new") {
                mConstruit()
            }
            //if (typeof itemData != 'undefined') {
            //    timeOutUpdate = window.setTimeout(function () {
            //        var obj = option.bddCtrl.getObjet(itemData)
            //        dxGrid.mUpdateData(action, obj.mGetTable().id_table, obj.cle())
            //    }, 100)
            //}
        })

    var dxScroll = null
    this.mGetDxScroll = function () { return dxScroll }
    function mConstruit() {
        container.empty()
        container.css("user-select", "none")
        dxScroll = $("<div style='height:100%;'/>").appendTo(container).dxScrollView({}).dxScrollView("instance")

        var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0;'/>").appendTo(dxScroll.content())
        var $DivBt = (new cBuilderEmailWidgetTexte()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetTitre({ tag: "h1" })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        var $DivBt = (new cBuilderEmailWidgetTitre({ tag: "h2" })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetTitre({ tag: "h3" })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetTitre({ tag: "h4" })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetBouton()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetImage()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetVideo()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        if (parametre.code_appli == "cog" || option.isFormulaire) {
            var $DivBt = (new cBuilderEmailWidgetVideoEmbed()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        }

        var $DivBt = (new cBuilderEmailWidgetSeparateur()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        //var $DivBt = (new cBuilderEmailWidgetMenu()).mGetButton()
        //$DivBt.appendTo($("<li/>").appendTo($Ul))
        //option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetReseau()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        if (!option.isFormulaire) {
            var $DivBt = (new cBuilderEmailWidgetDesinscription()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetOuvreNavigateur()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            if (!option.isFormulaire && (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base == "masc_aagest")) {
                var $DivBt = (new cBuilderEmailWidgetVoirDansNavigateur()).mGetButton()
                $DivBt.appendTo($("<li/>").appendTo($Ul))
                option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
            }
        }

        //var $DivBt = (new cBuilderEmailWidgetRetourTop()).mGetButton()
        //$DivBt.appendTo($("<li/>").appendTo($Ul))
        //option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetMarge()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        var $DivBt = (new cBuilderEmailWidgetCode()).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        if (option.bddCtrl.baseAppli.para.email.has_reception_email && !option.isFormulaire) {
            var $DivBt = (new cBuilderEmailWidgetSignature()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        }

        if (!option.isFormulaire && (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base=="masc_aagest")) {
            $("<hr/>").appendTo(dxScroll.content())
            $("<div style='opacity:0.5;'>&nbsp;RGPD</div>").appendTo(dxScroll.content())

            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())

            var $DivBt = (new cBuilderEmailWidgetRGPDTout()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetRGPDDesinscription()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetRGPDDesactivePixelTracking()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetRGPDNomsociete()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetRGPDPolitiqueConf()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetRGPDSource()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        }


        //$("<br/>").appendTo(dxScroll.content())
        $("<hr/>").appendTo(dxScroll.content())
        $("<div style='opacity:0.5;'>&nbsp;BLOC/COLONNES</div>").appendTo(dxScroll.content())

        var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
        var $DivBt = (new cBuilderEmailWidgetColonne({ nbCol: 1 })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        var $DivBt = (new cBuilderEmailWidgetColonne({ nbCol: 2 })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        var $DivBt = (new cBuilderEmailWidgetColonne({ nbCol: 3 })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        var $DivBt = (new cBuilderEmailWidgetColonne({ nbCol: 4 })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        var $DivBt = (new cBuilderEmailWidgetColonne({ nbCol: 5 })).mGetButton()
        $DivBt.appendTo($("<li/>").appendTo($Ul))
        option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

        if (option.isFormulaire) {
            $("<hr/>").appendTo(dxScroll.content())
            $("<div style='opacity:0.5;'>&nbsp;VALIDATION FORMULAIRE</div>").appendTo(dxScroll.content())
            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
            var $DivBt = (new cBuilderEmailWidgetCtrlBtValide()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            $("<div style='opacity:0.5;'>&nbsp;CHAMPS COORDONNEES</div>").appendTo(dxScroll.content())
            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
            var $DivBt = (new cBuilderEmailWidgetCtrlTextBoxNomStr()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlTextBoxNomCon()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlTextBoxPrenomCon()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlEmail()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlAdrPostale()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlWeb()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
            var $DivBt = (new cBuilderEmailWidgetCtrlTel()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlTelTel()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlTelMob()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")


            $("<div style='opacity:0.5;'>&nbsp;SAISIE LIBRE</div>").appendTo(dxScroll.content())
            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
            var $DivBt = (new cBuilderEmailWidgetCtrlTextBox()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlTextArea()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlCheckBox()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlDateBox()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlNumberBox()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")

            var $DivBt = (new cBuilderEmailWidgetCtrlSelect()).mGetButton()
            $DivBt.appendTo($("<li/>").appendTo($Ul))
            option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
        }

        if (lstWidgetPerso == null) {
            mInitWidgetPerso(function () {
                mRempliWidgetPerso()
            })
        } else { mRempliWidgetPerso() }

    }

    var timeoutReloadWidget = null
    function mRempliWidgetPerso() {
        if (lstWidgetPerso.length > 0) {
            $("<hr/>").appendTo(dxScroll.content())
            var $Ul = $("<ul style='display:flex;flex-wrap:wrap;list-style-type:none;margin:5px;padding:0'/>").appendTo(dxScroll.content())
            lstWidgetPerso.forEach(function (dataWidgetPerso) {
                var $li = $("<li/>").appendTo($Ul)
                var $DivBt = (new cBuilderEmailWidgetPerso({
                    data: dataWidgetPerso,
                    bddCtrl: option.bddCtrl
                })).mGetButton()
                $DivBt.appendTo($li)
                option.dxBuilderEmailPage.mInitDrag($DivBt, "clone")
            })
            window.clearTimeout(timeoutReloadWidget)
            timeoutReloadWidget = window.setTimeout(function () { mInitWidgetPerso() }, 5000)
        }
    }

    function mInitWidgetPerso(funcOk) {
        option.bddCtrl.mAjaxCall({
            command: "getdataswidgetemail"
        }, function (data) {
            data.lstwidgetperso = JSON.parse(data.lstwidgetperso)
            //if (typeof data.lstwidgetperso == 'undefined') data.lstwidgetperso = []
            lstWidgetPerso = data.lstwidgetperso
            if (typeof lstWidgetPerso == 'undefined') lstWidgetPerso = []
            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    this.element = function () { return container }

    mConstruit();
}